<div [class.cm-hint-info]="$hintType() === hintTypes.Info" [class.cm-hint-warning]="$hintType() === hintTypes.Warning" class="cm-hint-container">
    <i class="far fa-circle-info cm-hint-info-icon"></i>
    <ng-content select="[cm-text]"></ng-content>
</div>
